import PD1 from '../assets/images/thumbnails/PD1.jpg'
import PD2 from '../assets/images/thumbnails/PD2.jpg'
import PD3 from '../assets/images/thumbnails/PD3.jpg'
import PD4 from '../assets/images/thumbnails/PD4.jpg'
import PD5 from '../assets/images/thumbnails/PD5R.png'
import PD6 from '../assets/images/thumbnails/PD6R.png'
import PDP1 from '../assets/images/preview/PDP1.png'
import PDP2 from '../assets/images/preview/PDP2.png'
import PDP3 from '../assets/images/preview/PDP3.png'
import PDP4 from '../assets/images/preview/PDP4.png'
import PDP5 from '../assets/images/preview/PDP5.png'
import PDP6 from '../assets/images/preview/PDP6.png'
import PD7 from '../assets/images/thumbnails/PD7.png'
import PDP7 from '../assets/images/preview/PDP7.png'
import PD8 from '../assets/images/thumbnails/PD8.png'
import PDP8 from '../assets/images/preview/PD8.png'
import PDLogo from '../assets/images/logo/LogoPD.png'

const PD = [
  {
    id: 1,
    section: 'PD',
    title: 'Preguntas Dimensionales #1',
    thumbnailUrl: PD1,
    webUrl: 'https://www.youtube.com/embed/5uZgIUZChFU', // Add the episode URL
    backgroundImage: PDP1,
    seriesLogo: PDLogo,
    description: 'Dejen todas sus preguntas en los comentarios. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
  },
  {
    id: 2,
    section: 'PD',
    title: 'Preguntas Dimensionales #2',
    thumbnailUrl: PD2,
    webUrl: 'https://www.youtube.com/embed/g--tjNDJmbs', // Add the episode URL
    backgroundImage: PDP2,
    seriesLogo: PDLogo,
    description: 'No olviden hacer TODAS LAS PREGUNTAS que se les antoje, adelante, recuerden, tienen 1 mes. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
  },
  {
    id: 3,
    section: 'PD',
    title: 'Preguntas Dimensionales #3',
    thumbnailUrl: PD3,
    webUrl: 'https://www.youtube.com/embed/3BO5Ee0sKHw', // Add the episode URL
    backgroundImage: PDP3,
    seriesLogo: PDLogo,
    description: 'Favor de ver el video completo antes de hacer sus preguntas nuevas. Si usted se sintió ofendido con este video le pido una disculpa, mi única intención es hacerle reir y entretenerle. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
  },
  {
    id: 4,
    section: 'PD',
    title: 'Preguntas Dimensionales #4',
    thumbnailUrl: PD4,
    webUrl: 'https://www.youtube.com/embed/U4TSNXVFTV8', // Add the episode URL
    backgroundImage: PDP4,
    seriesLogo: PDLogo,
    description: 'Disculpen la tardanza pero finalmente aquí está la cuarta parte!! Disfrutenlo :] Y no olviden enviar sus preguntas, recuerden que tienen tiempo hasta que yo les avise, pero les aseguro que es más de 1 mes, aún así, no vayan a enviar sus preguntas hasta el final... quiero preguntas.... ahora...... .___. Okno XD',
  },
  {
    id: 5,
    section: 'PD',
    title: 'Preguntas Dimensionales #5',
    thumbnailUrl: PD5,
    webUrl: 'https://www.youtube.com/embed/nVe5K57x764', // Add the episode URL
    backgroundImage: PDP5,
    seriesLogo: PDLogo,
    description: 'Link y Ezlo regresan con nuevas preguntas!',
  },
  {
    id: 6,
    section: 'PD',
    title: 'Preguntas Dimensionales #6',
    thumbnailUrl: PD6,
    webUrl: 'https://www.youtube.com/embed/RTdchjQHDnA', // Add the episode URL
    backgroundImage: PDP6,
    seriesLogo: PDLogo,
    description: 'Visuales (Ezlo):  @TomySiete',
  },
  {
    id: 7,
    section: 'PD',
    title: 'Preguntas Dimensionales #7',
    thumbnailUrl: PD7,
    webUrl: 'https://www.youtube.com/embed/TMSK82x_cHU', // Add the episode URL
    backgroundImage: PDP7,
    seriesLogo: PDLogo,
    description: 'Visuales (Ezlo):  @TomySiete',
  },
  {
    id: 8,
    section: 'PD',
    title: 'Preguntas Dimensionales #8 || El Adios de Ezlo',
    thumbnailUrl: PD8,
    webUrl: 'https://www.youtube.com/embed/hqdeVZ3IZO8', // Add the episode URL
    backgroundImage: PDP8,
    seriesLogo: PDLogo,
    description: 'Link y Ezlo regresan a darnos las respuestas a todas sus preguntas! Solo que en esta ocasión, Ezlo tiene una noticia muy importante que compartir. En este video hay información importante del episodio 13 y de otros episodios tambien... Gracias a todos por enviar sus preguntas. Como pueden ver, estos videos se van haciendo cada vez más grandes en duración. Puede que este sea el último video de preguntas en este formato. Espero lo disfruten y nos vemos proximamente!!',
  },
  ];

  export default PD;
